import { authApi } from '../';
import { LoginUserModel, LoginResponse, ExchangeRequest } from 'src/types';

export const loginUser = (data: LoginUserModel) =>
  authApi.post<LoginResponse>('/auth/login', data, { withCredentials: true });

export const exchangeSsoCode = (data: ExchangeRequest) => authApi.post<LoginResponse>('/auth/sso/exchange', data);
